import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { MapPin, Clock } from "lucide-react";
import PromoStrip from "@/components/site/PromoStrip";
import { useAuth } from "@/lib/auth";
import { useCurrency } from "@/lib/currency";
import { toast } from "sonner";

export default function Sightseeing() {
  const { format: fmt } = useCurrency();
  const [items, setItems] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { (async () => { const { data } = await api.get("/sightseeing"); setItems(data); })(); }, []);

  const book = async (s) => {
    if (!user) { toast.error("Please sign in to continue"); return; }
    const { data } = await api.post("/bookings", {
      booking_type: "sightseeing", item: s, travelers: [{ name: user.name }],
      total_amount: s.price, currency: "USD", contact: { email: user.email, name: user.name },
    });
    navigate(`/checkout/${data.id}`);
  };

  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      <div className="bg-gradient-to-br from-[var(--brand-accent)] to-[var(--brand-primary-dark)] rounded-3xl p-6 md:p-8 text-white">
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold">Unforgettable experiences</h1>
        <p className="mt-2 text-teal-50/90 max-w-xl">Skip the lines, meet local guides, and live the moments that postcards can't show.</p>
      </div>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-4 gap-5 stagger">
        {items.map((s) => (
          <Card key={s.id} data-testid={`sightseeing-card-${s.id}`} className="overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-all">
            <div className="h-40"><img src={s.image} alt={s.title} className="w-full h-full object-cover" /></div>
            <div className="p-4">
              <h3 className="font-heading text-base font-semibold text-[var(--brand-accent)] leading-tight">{s.title}</h3>
              <div className="flex items-center gap-3 text-xs text-slate-500 mt-1">
                <span className="flex items-center gap-1"><MapPin className="w-3 h-3" />{s.city}</span>
                <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{s.duration}</span>
              </div>
              <div className="flex items-center justify-between mt-3">
                <div className="font-heading font-bold text-[var(--brand-accent)]">{fmt(s.price, { decimals: 0 })}</div>
                <Button data-testid={`sightseeing-book-${s.id}`} size="sm" onClick={() => book(s)} className="bg-[var(--brand-primary)] hover:bg-[var(--brand-primary-dark)] rounded-full">Book</Button>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <PromoStrip />
    </div>
  );
}
